import { useSelector } from "react-redux";

const useGlobalData = () => {
  const globalData = useSelector((state) => state.globalData?.data);
  const {
    isAuthenticated,
    isSuggestPlatformVersionUpgrade,
    vendorData,
    frontendSettings,
    settings,
    features,
    enums,
    homePageBanners,
  } = globalData || {};

  return {
    globalData,
    isAuthenticated,
    isSuggestPlatformVersionUpgrade,
    vendorData,
    frontendSettings,
    settings,
    features,
    enums,
    homePageBanners,
  };
};

export default useGlobalData;
